export default __webpack_public_path__ + "assets/models/0078eba5b2cff835fe5d8b96c3a27c9e.glb";